import { equals, is, mergeRight } from "ramda"

const checkAction = (pattern, action) =>
  is(Function, pattern) ? pattern(action) : equals(pattern, action.type)

export const status = (
  requestedPattern,
  succeededPattern,
  failedPattern,
  cancelledPattern = "ASYNC_STATE/RESET",
) => (statusState = { loaded: false, pending: false, error: false }, action) => {
  if (checkAction(requestedPattern, action)) {
    return mergeRight(statusState, {
      pending: true,
    })
  } else if (checkAction(succeededPattern, action)) {
    return mergeRight(statusState, {
      loaded: true,
      pending: false,
      error: false,
    })
  } else if (checkAction(failedPattern, action)) {
    const error = action.payload ? action.payload.error : true

    return mergeRight(statusState, {
      pending: false,
      error,
    })
  } else if (checkAction(cancelledPattern, action)) {
    return {
      loaded: false,
      pending: false,
      error: false,
    }
  }

  return statusState
}
